define( [
	"../var/support"
], function( support ) {

support.focusin = "onfocusin" in window;

return support;

} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/event/support.js
// module id = 2140
// module chunks = 0